export default "__VITE_ASSET__Ufd_VjJ6__"